var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"back"},[_c('img',{attrs:{"src":require("../images/u3.png")},on:{"click":_vm.getBack}}),_c('span',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }